/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 20, height = 20 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M9.16406 13.8222V15.8339C9.16406 16.0549 9.07627 16.2669 8.91999 16.4232C8.7637 16.5794 8.55174 16.6672 8.33073 16.6672H1.66406L15.3057 3.02558C15.6373 2.69406 16.0869 2.50781 16.5557 2.50781C17.0246 2.50781 17.4742 2.69406 17.8057 3.02558C18.1373 3.3571 18.3235 3.80674 18.3235 4.27558C18.3235 4.74442 18.1373 5.19406 17.8057 5.52558L9.75323 13.5781C9.59696 13.7343 9.38503 13.8222 9.16406 13.8222ZM9.16406 13.8222C8.94309 13.8222 8.73117 13.7343 8.5749 13.5781L6.66406 11.6672" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
